<template>
  <div>
    <MainHeader />
    <div class="timeline-container">
      <div class="lineleft">
        <div>
          <div class="entry-list">
            <div class="nav-tab">
              <div
                class="tabItem"
                :class="{ active: state.isActive === 1 }"
                @click="handleTabClick(1)">
                推荐
              </div>
              <div
                class="tabItem"
                :class="{ active: state.isActive === 2 }"
                @click="handleTabClick(2)">
                最新
              </div>
            </div>
            <div class="article-list">
              <el-skeleton
                :loading="isLoading"
                style="margin-top: 15px"
                :rows="4"
                animated>
                <template #template>
                  <el-skeleton-item
                    variant="text"
                    style="width: 45%" />
                  <el-skeleton-item
                    variant="text"
                    style="width: 60%" />
                  <el-skeleton-item
                    variant="text"
                    style="width: 85%" />
                  <el-skeleton-item
                    variant="text"
                    style="width: 100%" />
                </template>
              </el-skeleton>
              <div
                class="infor-list"
                v-for="articleitem in articles"
                :key="articleitem.article_id">
                <div class="flow-header">
                  <a
                    :href="`/user/${articleitem.uuid}`"
                    target="_blank"
                    :title="'查看' + articleitem.author + ' 的个人主页'"
                    class="titlelink">
                    <div class="user">
                      <img
                        :src="articleitem.avatar_url"
                        class="avatar" />
                      <span class="name">{{ articleitem.author }}</span>
                    </div>
                  </a>
                  <div class="info">
                    <div class="date">
                      {{ formatDate(articleitem.created_at) }}
                    </div>
                  </div>
                </div>
                <div class="content-wrapper">
                  <div>
                    <div class="info">
                      <a
                        :href="`/post/${articleitem.article_id}`"
                        :title="articleitem.title"
                        class="titlelink"
                        target="_blank"
                        ><h1 class="title">{{ articleitem.title }}</h1></a
                      >
                      <a
                        :href="`/post/${articleitem.article_id}`"
                        class="titlelink"
                        target="_blank"
                        ><div class="content">
                          {{ articleitem.brief_content }}
                        </div></a
                      >
                    </div>
                    <!-- <div class="dataview">
                    <span> · 1083 点赞</span>
                    <span> · 46 留言</span>
                  </div> -->
                  </div>
                  <div
                    class="img"
                    v-if="articleitem.cover_image">
                    <div class="user-image">
                      <a
                        :href="`/post/${articleitem.article_id}`"
                        class="titlelink"
                        target="_blank">
                        <img
                          class="image-loct"
                          :src="articleitem.cover_image"
                          width="192"
                          height="128"
                          loading="lazy"/></a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="showLoadMore && hasMore"
                class="load-more"
                @click="handleManualLoad"
                style="text-align: center; padding-top: 50px">
                {{ isLoading ? "加载中..." : "加载更多" }}
              </div>
              <div
                v-if="isLoading && !showLoadMore"
                style="text-align: center; padding-top: 50px">
                加载中...
              </div>
              <div v-if="!hasMore">
                <div style="text-align: center; padding-top: 50px">
                  暂无数据
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="index-aside"></div>
        <div class="sidebar-block banner-block">
          <div class="banner">
            <img
              src="@/assets/ad/2025/sidebar_banner_202504.jpg"
              class="banner-image" />
          </div>
        </div>
        <div class="index-aside-footer">
          <ul class="more-list">
            <li class="item">
              <a
                href="https://x0pcacndwxb.feishu.cn/share/base/form/shrcn8CwaeQwQH3NSCO7JHidk1b"
                target="_blank"
                rel="nofollow"
                >问题反馈</a
              >
            </li>
            <li class="item">
              <a
                href="/about"
                target="_blank"
                >关于我们</a
              >
            </li>
          </ul>
          <ul class="more-list">
            <li class="item">
              联系我们：<a href="mailto:dcteams@163.com">dcteams{at}163.com</a>
            </li>
          </ul>
          <ul class="more-list">
            <li class="item">
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="nofollow"
                >备案号：浙ICP备2025171302号</a
              >
            </li>
          </ul>
          <ul class="more-list">
            <li class="item">
              <img
                :src="require('@/assets/img/police.20250527.png')"
                width="20"
                height="20" style="vertical-align:middle;" /><a
                href="https://beian.mps.gov.cn/#/query/webSearch?code=33020602001525"
                rel="noreferrer"
                target="_blank"
                >浙公网安备33020602001525号</a
              >
            </li>
          </ul>
          <ul class="more-list">
            <li class="item">
              <span> © {{ SSRData.copyright }} 默认代码</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, reactive, ref, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import MainHeader from "@/components/main-header.vue";
import axiosInstance from "@/utils/axiosInstance";
import { format } from "date-fns";
import { useHead } from "@vueuse/head";

const SSRData = ref({
  title: "默认代码",
  description:
    "默认代码,defaultcode.cn 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。",
  keywords:
    "默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区",
  copyright:new Date().getFullYear()
});

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: "description", content: SSRData.value.description },
    { name: "keywords", content: SSRData.value.keywords },
  ],
});

const router = useRouter();
const state = reactive({
  isActive: 1,
  sort: "",
});

//定义数据和接口类型
interface Article {
  article_id: string;
  title: string;
  brief_content: string;
  cover_image: string;
  uuid: string;
}

const formatDate = (date: string | Date) => {
  return format(new Date(date), "yyyy-MM-dd");
};

const articles = ref<Article[]>([]);
const currentPage = ref(1);
const isLoading = ref(false);
const loadCount = ref(0); // 自动加载计数器
const showLoadMore = ref(false); // 显示加载更多按钮
const hasMore = ref(true); // 是否还有更多数据

//信息流加载
const loadArticles = async (isAutoLoad: boolean) => {
  if (isLoading.value || !hasMore.value) return;
  isLoading.value = true;
  try {
    const response = await axiosInstance.get(
      "/api/HomeArticle/recommend_all_feed",
      {
        params: { page: currentPage.value, sort: state.sort },
      }
    );
    var result = response.data;
    if (result.success && result.data.dataCount > 0) {
      articles.value.push(...result.data.data);
      currentPage.value++;
      hasMore.value = currentPage.value <= result.data.pageCount;
      if (isAutoLoad) {
        loadCount.value++;
        showLoadMore.value = loadCount.value >= 5;
      }
    } else {
      hasMore.value = false;
    }
  } finally {
    isLoading.value = false;
  }
};

const handleScroll = () => {
  const scrollHeight = document.documentElement.scrollHeight;
  const clientHeight = window.innerHeight;
  const scrollTop = document.documentElement.scrollTop;

  // 距离底部50px时触发加载
  if (scrollHeight - (scrollTop + clientHeight) < 50) {
    if (hasMore.value && !showLoadMore.value && !isLoading.value) {
      loadArticles(true);
    }
  }
};

onMounted(async () => {
  window.addEventListener("scroll", handleScroll);
  loadArticles(false); // 初始加载
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const handleManualLoad = () => {
  if (!isLoading.value && hasMore.value) {
    loadArticles(false);
    showLoadMore.value = false; // 加载后隐藏按钮
  }
};

//tab切换
const handleTabClick = (tab: number) => {
  state.isActive = tab;
  if (tab === 1) {
    router.push({ path: "/" });
    state.sort = "";
    reFreshPage();
  } else {
    router.push({ path: "/", query: { sort: "newest" } });
    state.sort = "newest";
    reFreshPage();
  }
};

const reFreshPage = () => {
  currentPage.value = 1;
  isLoading.value = false;
  loadCount.value = 0;
  showLoadMore.value = false;
  hasMore.value = true;
  articles.value = [];
  loadArticles(false);
};
</script>

<style scoped>
/*文章列表 */
.timeline-container {
  display: flex;
  justify-content: space-between;
  max-width: 1020px;
  margin: 20px auto;
}
.lineleft {
  min-width: 720px;
  margin-right: 15px;
  background: #fff;
}

.entry-list {
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
}
/* 内容主体区 */
.article-list {
  min-height: 850px;
}
/*Tab */
.nav-tab {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #e9e9e9;
}
.nav-tab .tabItem {
  padding: 0 0 9px 0;
  margin-right: 28px;
  font-size: 16px;
  color: #ababae;
  cursor: pointer;
}
.nav-tab .tabItem.active {
  color: #413e3b;
  font-weight: 500;
  border-bottom: 2px solid #b14b43;
}
/*信息流 */
.infor-list {
  font-size: 16px;
  line-height: 26px;
  border-bottom: 1px solid #e5e5e5;
  padding: 10px 0 8px;
}
.flow-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.flow-header .user {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flow-header .user .avatar {
  width: 20px;
  height: 20px;
  border-radius: unset;
  margin-right: 5px;
}
.flow-header .user span {
  font-size: 14px;
  font-weight: 900;
}
.flow-header .info {
  font-size: 12px;
  color: #ababae;
}
.flow-header .user .name {
  font-weight: 800;
  font-size: 12px;
  line-height: 18px;
}
.flow-header .user .date {
  font-size: 12px;
  line-height: 13px;
  margin-top: 3px;
  color: #ababae;
}
.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 1 auto;
  margin-top: 2px;
  position: relative;
}
.info .title {
  cursor: pointer;
  margin: 0 auto;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  font-size: 16px;
}
.info:hover .title {
  color: #cc5656;
}
.titlelink {
  color: #000;
}
.info .content {
  font-size: 14px;
  color: #9d9d9d;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 26px;
  height: 46px;
}
.dataview {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #acabae;
  margin-top: 10px;
}
.empty-box {
  height: 8px;
  display: block;
}
.user-image {
  width: 108px;
  height: 72px;
  border-radius: 6px;
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  overflow: hidden;
}
.image-loct {
  width: 100%;
  height: 100%;
  vertical-align: top;
  background-color: #f5f5f5;
  object-fit: cover;
}
/* 懒加载图片过渡效果 */
img[lazy=loaded] {
  animation: fadeIn 0.5s;
}
img[lazy=loading] {
  opacity: 0;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
/*
右侧
*/

.index-aside {
  width: 300px;
}
.sidebar-block {
  background-color: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  margin-bottom: 18px;
  font-size: 13px;
  border-radius: 4px;
  color: #252933;
}
.signin-tip {
  padding: 20px;
  box-sizing: border-box;
}
.first-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.first-line .icon-text {
  display: flex;
  flex-direction: column;
}
.first-line .title {
  color: #252933;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.first-line .title-days {
  margin-left: 4px;
  color: var(--juejin-font-brand1-normal);
}
.first-line .btn {
  border-radius: 4px;
  height: 36px;
  width: 74px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(30, 128, 255, 0.3);
  background-color: rgba(30, 128, 255, 0.05);
}

.first-line .btn-text {
  color: #1e80ff;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
}

.first-line .signed-text {
  color: #abcdff;
}

.second-line {
  color: #8a919f;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 2px;
}
.sidebar-block.banner-block {
  overflow: hidden;
}
.sidebar-block li {
  list-style: none;
}
.sidebar-block.banner-block .banner {
  position: relative;
  font-size: 0;
  cursor: pointer;
}
.banner .banner-image {
  width: 100%;
  height: 100%;
}

ul {
  padding: 0;
  margin: 0;
}
li {
  list-style: none;
}
.index-aside-footer {
  background-color: transparent;
  box-shadow: none;
}
.index-aside-footer .more-list {
  font-size: 12px;
  line-height: 1.6;
  color: #9aa3ab;
}
.index-aside-footer .more-list:after {
  display: table;
  content: "";
  clear: both;
}
.index-aside-footer .more-list .item {
  float: left;
  margin-bottom: 8px;
}
.index-aside-footer .more-list .item:not(:last-child):after {
  content: "";
  margin-right: 12px;
}
.index-aside-footer .more-list .item a,
.index-aside-footer .more-list .item span {
  color: #8a919f;
}
</style>
